import axios from 'axios';
import envService from '@/services/env.service';

const BASE_URL = envService.getApiBaseUrl() + '/sms/statistics';

export default {
    async getAllUsersStatsByMonths(months) {
        const response = await axios.get(BASE_URL + '/all/bymonths/' + months);
        return response.data;
    },

    async getAllUsersStatsByDays(days) {
        const response = await axios.get(BASE_URL + '/all/bydays/' + days);
        return response.data;
    },
};